// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Choose Client Placeholder ── */

.choose-client-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 70vh;
  text-align: center;
  padding: 40px;
  position: relative;
  z-index: 1;
}

.choose-client-orb {
  width: 140px;
  height: 140px;
  border-radius: 50%;
  background: radial-gradient(circle at 40% 40%,
    rgba(255, 107, 74, 0.15) 0%,
    rgba(233, 75, 108, 0.12) 35%,
    rgba(142, 58, 154, 0.08) 65%,
    rgba(142, 58, 154, 0.02) 100%
  );
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;
}

.choose-client-title {
  font-size: 22px;
  font-weight: 700;
  color: var(--text-primary, #1a1a1a);
  margin-bottom: 10px;
}

.choose-client-text {
  font-size: 15px;
  color: var(--text-secondary, #868e96);
  max-width: 320px;
  line-height: 1.6;
  margin-bottom: 28px;
}

.choose-client-btn {
  padding: 14px 40px;
  border: none;
  border-radius: 14px;
  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 50%, #8E3A9A 100%);
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(255, 107, 74, 0.25);
  transition: transform 0.15s, box-shadow 0.15s;
}

.choose-client-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 24px rgba(255, 107, 74, 0.35);
}

.choose-client-btn:active {
  transform: translateY(0);
}

/* ── Overlay: not used as a DOM element anymore ── */
.choose-client-overlay {
  display: none;
}

/* ── Sidebar dim: pseudo-element on sidebar itself ── */
body.client-highlight-active .sidebar::after {
  content: '';
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.25);
  z-index: 50;
  pointer-events: none;
  animation: overlayFadeIn 0.2s ease;
}

/* Main content dim */
body.client-highlight-active .main-content::after {
  content: '';
  position: fixed;
  top: 0;
  left: 280px;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.25);
  z-index: 50;
  pointer-events: none;
  animation: overlayFadeIn 0.2s ease;
}

@keyframes overlayFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* Client section sits above the sidebar dim overlay */
body.client-highlight-active .client-section {
  position: relative;
  z-index: 60;
}

body.client-highlight-active .client-section .client-nav-item {
  background: #fafbfc;
  border-radius: 12px;
  box-shadow: 0 0 0 4px rgba(255, 107, 74, 0.15);
}

body.client-highlight-active .client-dropdown {
  z-index: 70;
}
`, "",{"version":3,"sources":["webpack://./src/styles/choose-client.css"],"names":[],"mappings":"AAAA,oCAAoC;;AAEpC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB;;;;;GAKC;EACD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,0EAA0E;EAC1E,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,+CAA+C;EAC/C,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,qDAAqD;AACrD;EACE,aAAa;AACf;;AAEA,wDAAwD;AACxD;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;EAC/B,WAAW;EACX,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,eAAe;EACf,MAAM;EACN,WAAW;EACX,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,WAAW;EACX,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA,sDAAsD;AACtD;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,WAAW;AACb","sourcesContent":["/* ── Choose Client Placeholder ── */\n\n.choose-client-placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 70vh;\n  text-align: center;\n  padding: 40px;\n  position: relative;\n  z-index: 1;\n}\n\n.choose-client-orb {\n  width: 140px;\n  height: 140px;\n  border-radius: 50%;\n  background: radial-gradient(circle at 40% 40%,\n    rgba(255, 107, 74, 0.15) 0%,\n    rgba(233, 75, 108, 0.12) 35%,\n    rgba(142, 58, 154, 0.08) 65%,\n    rgba(142, 58, 154, 0.02) 100%\n  );\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 32px;\n}\n\n.choose-client-title {\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--text-primary, #1a1a1a);\n  margin-bottom: 10px;\n}\n\n.choose-client-text {\n  font-size: 15px;\n  color: var(--text-secondary, #868e96);\n  max-width: 320px;\n  line-height: 1.6;\n  margin-bottom: 28px;\n}\n\n.choose-client-btn {\n  padding: 14px 40px;\n  border: none;\n  border-radius: 14px;\n  background: linear-gradient(135deg, #FF6B4A 0%, #E94B6C 50%, #8E3A9A 100%);\n  color: #fff;\n  font-size: 15px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  box-shadow: 0 4px 16px rgba(255, 107, 74, 0.25);\n  transition: transform 0.15s, box-shadow 0.15s;\n}\n\n.choose-client-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 24px rgba(255, 107, 74, 0.35);\n}\n\n.choose-client-btn:active {\n  transform: translateY(0);\n}\n\n/* ── Overlay: not used as a DOM element anymore ── */\n.choose-client-overlay {\n  display: none;\n}\n\n/* ── Sidebar dim: pseudo-element on sidebar itself ── */\nbody.client-highlight-active .sidebar::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.25);\n  z-index: 50;\n  pointer-events: none;\n  animation: overlayFadeIn 0.2s ease;\n}\n\n/* Main content dim */\nbody.client-highlight-active .main-content::after {\n  content: '';\n  position: fixed;\n  top: 0;\n  left: 280px;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.25);\n  z-index: 50;\n  pointer-events: none;\n  animation: overlayFadeIn 0.2s ease;\n}\n\n@keyframes overlayFadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n/* Client section sits above the sidebar dim overlay */\nbody.client-highlight-active .client-section {\n  position: relative;\n  z-index: 60;\n}\n\nbody.client-highlight-active .client-section .client-nav-item {\n  background: #fafbfc;\n  border-radius: 12px;\n  box-shadow: 0 0 0 4px rgba(255, 107, 74, 0.15);\n}\n\nbody.client-highlight-active .client-dropdown {\n  z-index: 70;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
